<div class="col-12">
  <ngx-spinner
    name="upsSpinner"
    bdColor="rgba(255, 255, 255, 0.8)"
    size="medium"
    color="#321815"
    type="custom"
    [fullScreen]="true">
    <app-spinner></app-spinner>
  </ngx-spinner>


  @if (!isLoader) {
    <div>
      <div class="card card-body card-approval-history">
        <span class="list-title">Approval History</span>

        <div class="filter-container col-12">
          <form [formGroup]="dateForm" class="filter-form">
          
            <mat-form-field id="startDate" class="filter-field">
              <mat-label>Start Date</mat-label>
              <input
                class="fs-13"
                formControlName="startDate"
                matInput
                [matDatepicker]="startDatepicker"
                [errorStateMatcher]="matcher"
                placeholder="MM/DD/YYYY"
                name="startDate"/>
                <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatepicker></mat-datepicker>
                @if (dateForm.hasError('dateRangeInvalid')) {
                  <mat-error class="date-error">
                    Start Date should be less than End Date.
                  </mat-error>
                }
              </mat-form-field>

              <mat-form-field id="endDate" class="filter-field">
                <mat-label>End Date</mat-label>
                <input
                  class="fs-13"
                  formControlName="endDate"
                  matInput
                  [matDatepicker]="endDatepicker"
                  [errorStateMatcher]="matcher"
                  placeholder="MM/DD/YYYY"
                  name="endDate"/>
                  <mat-datepicker-toggle matSuffix [for]="endDatepicker"></mat-datepicker-toggle>
                  <mat-datepicker #endDatepicker></mat-datepicker>
                  @if (dateForm.hasError('dateRangeInvalid')) {
                    <mat-error class="date-error">
                      End Date should be more than Start Date.
                    </mat-error>
                  }
                </mat-form-field>

                <!--- <mat-form-field id="statusFilter" class="filter-field">
                <mat-label>Status</mat-label>
                <mat-select formControlName="statusFilter" name="statusFilter">
                  <mat-option value="0">All</mat-option>
                  <mat-option value="5">Approved</mat-option>
                  <mat-option value="4">Rejected</mat-option>
                  <mat-option value="3">Need More Information</mat-option>
                </mat-select>
              </mat-form-field>-->

              <button type="button" id="btnApply" (click)="onSubmit()" class="btn btn-yellow-filled">
                <i class="fas fa-search"></i> Apply
              </button>
            </form>
          </div>

          <app-dynamictable
            [displayedColumns]="displayedColumns"
            [dataSource]="dataSource"
            [totalCount]="totalCount"
            [pageSize]="pageSize"
            [useManualPaging]="true"
            [activeFilters]="currentAppliedFilters"
            (openDialog)="openViewInvoiceDialog($event)"
            (filterChange)="onSubmit(1, 10, $event.filters, false)"
            (paginationChange)="onSubmit($event.pageIndex + 1, $event.pageSize, [], $event.isRefresh || false)">
          </app-dynamictable>
        </div>
      </div>
    }
  </div>
